import TextDocument from './TextDocument'
function parsed(value: unknown): unknown { if(typeof value==='string'){try{return JSON.parse(value)}catch{return value}} return value }
const formatted = (value: unknown) => typeof value==='string' ? value : JSON.stringify(value,null,2)
export default function DiagnosticContent({value,kind}: {value:unknown;kind:'input'|'output'}) {
  const raw=value as Record<string,unknown> | null
  let content=value
  if(kind==='output' && raw && typeof raw==='object' && Array.isArray(raw.choices)) {
    const values=(raw.choices as {message?:{content?:unknown};text?:unknown}[]).map(choice=>choice.message?.content??choice.text).filter(item=>item!=null).map(parsed)
    content=values.length===1 ? values[0] : values
  }
  return <>
    <TextDocument label={kind==='output'?'Generated output':'Saved input'} text={formatted(content)} code={typeof content!=='string'}/>
    {content!==value && <details className="quiet-details"><summary>Raw provider response</summary><TextDocument label="Complete response" text={formatted(value)} code/></details>}
  </>
}
